import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple, FuseAnimate} from '@fuse';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';

import { Paper, Dialog, DialogContent, DialogActions, Button, Grid, Typography, TextField, Checkbox, DialogTitle } from '@material-ui/core';

import SyncIcon from '@material-ui/icons/Sync';
import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '@material-ui/icons/Info';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import Pagination from "material-ui-flat-pagination";

import History from '../../../history';

const styles = theme => ({
    layoutRoot: {},
    DialogPengguna: {
        width: '100%'
    },
    buttonSimpan: {
        backgroundColor: green[500],
        color: 'white',
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    buttonTutup: {
        backgroundColor: red[500],
        color: 'white',
        '&:hover': {
            backgroundColor: red[700],
        },
    }
});

class DaftarPtkDapodik extends Component {
    state = {
        dialogOpen: false,
        dialogOpenSalin: false,
        nama: '',
        email: '',
        password: '',
        konfirmasi_password: '',
        sekolah_id: this.props.location.pathname.split('/')[2],
        routeParams: {
            sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
            semester_id: localStorage.getItem('tahun') + "1",
            start: 0,
            limit: 20,
            jenis_salin: 'ptk'
        },
        checked: [],
        offset: 0,
        total: 0,
        hasil: {
            insert_berhasil: 0,
            update_berhasil: 0
        }
    }

    tutupDialog = () => {
        // this.props.toggleFormPengguna(false, '');
        this.setState({
            dialogOpen: false
        });

        if(this.state.kode === 'berhasil'){
            this.props.history.push('ManajemenPengguna')
        }
    }

    handleChange = name => event => {
        this.setState({
          [name]: event.target.value,
          routeParams: {
              ...this.state.routeParams,
              [name]: event.target.value,
          }
        });
    };

    componentDidMount = () => {
        // alert(this.props.location.pathname.split('/')[2]);

        let checked = [];

        this.props.setLoadingBesar(true);

        this.props.getPtkDapodik(this.state.routeParams).then((result)=>{
            // this.props.ptk_dapodik.rows.map((option)=>{
            //     checked[option.pd_ptk_id] = false;
            // });

            const array = this.props.ptk_dapodik.rows;
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                checked[element.pd_ptk_id] = false;
            }

            this.setState({
                checked,
                total: this.props.ptk_dapodik.total
            },()=>{
                // console.log(this.state);
                this.props.setLoadingBesar(false);
            });
        });
    }

    loadData = (e, offset) => {

        this.props.setLoadingBesar(true);

        this.setState({
            offset: offset,
            routeParams: {
                ...this.state.routeParams,
                start: offset
            }
        },()=>{
            this.props.getPtkDapodik(this.state.routeParams).then((result)=>{
                this.setState({
                    total: this.props.ptk_dapodik.total
                },()=>{
                    // console.log(this.state);
                    this.props.setLoadingBesar(false);
                });
            });
        });

        // console.log(offset);
    }

    checkboxTerpilih = (event, checked) => {

        this.setState({
            ...this.state,
            checked: {
                ...this.state.checked,
                [event.currentTarget.name] : !this.state.checked[event.currentTarget.name]
            }
        },()=>{
            console.log(this.state);
        });
    }

    CariKeyword = () => {
        this.props.setLoadingBesar(true);
        this.setState({
            ...this.state,
            offset: 0,
            routeParams: {
                ...this.state.routeParams,
                start: 0
            }
        },()=>{
            this.props.getPtkDapodik(this.state.routeParams).then((result)=>{
                this.setState({
                    total: this.props.ptk_dapodik.total
                },()=>{
                    // console.log(this.state);
                    this.props.setLoadingBesar(false);
                });
            });
        });
        
    }

    salinData = () => {
        console.log(this.state.checked);
        let array = [];

        for (const key in this.state.checked) {
            if (this.state.checked.hasOwnProperty(key)) {
                const element = this.state.checked[key];
                
                if(element === true){
                    array.push(key);
                }

                // console.log(element);
            }
        }


        // for (let index = 0; index < this.state.checked.length; index++) {
        //     const element = this.state.checked[index];

        //     console.log(element);

        //     if(element === true){
        //         array.push(element);
        //     }
        // }

        this.props.setLoadingBesar(true);

        this.setState({
            routeParams:{
                ...this.state.routeParams,
                ptk_id: JSON.stringify(array)
            }
        },()=>{
            this.props.salinPesertaDidik(this.state.routeParams).then((result)=>{
                // console.log(result.payload);
                this.props.setLoadingBesar(false);
                
                this.setState({
                    ...this.state,
                    dialogOpenSalin: true,
                    hasil: {
                        insert_berhasil: result.payload.insert_berhasil,
                        update_berhasil: result.payload.update_berhasil,
                    }
                })
            })
        });

        // console.log(JSON.stringify(array));
    }

    tutupDialogSalin = () => {
        this.setState({
            dialogOpenSalin: false
        });
    }

    render()
    {
        const {classes} = this.props;
        
        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot,
                    header: classes.headerUtama
                }}
                content={
                    <div style={{width: '100%'}} className="konten-utama">
                        <Dialog
                            open={this.state.dialogOpenSalin}
                        >
                            <DialogTitle>
                                Hasil Salin PTK
                            </DialogTitle>
                            <DialogContent>
                                Data Baru: {this.state.hasil.insert_berhasil}<br/>
                                Data Diperbarui: {this.state.hasil.update_berhasil}<br/>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.tutupDialogSalin}>
                                    <CloseIcon/> Tutup
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Button variant="extendedFab" className="FabSimpan" color="primary" onClick={this.salinData}>
                            <SyncIcon className={classes.extendedIcon} />
                            &nbsp; Salin Data
                        </Button>
                        <Dialog open={this.state.dialogOpen}>
                            <DialogContent>
                                {this.state.dialogText}
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.tutupDialog}>
                                    <CloseIcon/> Tutup
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <FuseAnimate
                        animation="transition.slideRightIn"
                        duration={400}
                        delay={400}
                        >
                            <Paper className="p-16 pb-64">
                                <Grid container>
                                    <Grid item xs={6} style={{textAlign:'left'}}>
                                        <Button onClick={()=>History.push('/ManajemenPengguna')}>
                                            <ArrowBackIcon/> Kembali
                                        </Button>
                                    </Grid>
                                    {/* <Grid item xs={6} style={{textAlign:'right'}}> */}
                                        {/* <Button variant="contained" color="primary" onClick={this.simpanForm}>
                                            <SaveIcon/> Simpan
                                        </Button> */}
                                    {/* </Grid> */}
                                </Grid>
                                {/* <br/> */}
                                {/* <br/> */}
                                <Typography variant="headline">
                                    Daftar PTK di Dapodik
                                </Typography>
                                <br/>
                                <Paper className="p-16" style={{background: '#F1F8E9'}}>
                                    <Grid container>
                                        <Grid item xs={12} sm={1}>
                                            <InfoIcon style={{fontSize:35, color: '#9CCC65'}}/>
                                        </Grid>
                                        <Grid item xs={12} sm={11}>
                                            <Typography variant="caption" style={{fontSize:'15px'}}>
                                                Daftar yang ditampilkan pada halaman ini adalah <b>data yang bersumber dari Dapodik</b>.
                                            </Typography>
                                            <Typography variant="caption" style={{fontSize:'15px'}}>
                                                Silakan ceklis data yang Anda pilih sebagai calon responden
                                            </Typography>
                                            <br/>
                                            <Typography variant="caption" style={{fontSize:'15px'}}>
                                                Format username untuk PTK: email<br/>
                                                format password untuk PTK: tanggal lahir (yyyy-mm-dd)
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Paper>
                                <br/>
                                <Paper className="p-8">
                                    <Grid container spacing={8}>
                                        <Grid item xs={9} sm={10}>
                                            <TextField
                                                id="keyword"
                                                label="Saring Nama/NISN"
                                                className={classes.textField}
                                                value={this.state.keyword}
                                                onChange={this.handleChange('keyword')}
                                                margin="normal"
                                                variant="outlined"
                                                style={{width: '100%', marginTop:'0px', marginBottom:'0px'}}
                                            />
                                        </Grid>
                                        <Grid item xs={3} sm={2}>
                                            <Button 
                                                variant="contained" 
                                                color="primary" 
                                                onClick={this.CariKeyword}
                                                style={{width:'100%', height:'50px'}}
                                            >
                                                Cari
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Pagination
                                            limit={20}
                                            offset={this.state.offset}
                                            total={this.state.total}
                                            innerButtonCount={1}
                                            style={{width: '100%'}}
                                            onClick={this.loadData}
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                                <br/>
                                {/* <Paper className="p-8 mt-8"> */}
                                    {this.props.ptk_dapodik.rows.map((option)=>{
                                        
                                        return (
                                            <Paper className="p-8 mt-8">
                                                <Grid container>
                                                    <Grid item xs={2} sm={1}>
                                                        <Checkbox
                                                            checked={this.state.checked[[option.pd_ptk_id]]}
                                                            onChange={this.checkboxTerpilih}
                                                            name={option.pd_ptk_id}
                                                            color="primary"
                                                            style={{padding:'0px'}}
                                                            // inputProps={{
                                                            //     ins_instrumen_id: (PilihanJawaban.ins_instrumen_id)
                                                            // }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={10} sm={11}>
                                                        <Typography variant="title" style={{fontSize:'1.7rem'}}>
                                                            {option.nama} {option.nuptk && option.nuptk !== ' ' && <span>({option.nuptk})</span>}
                                                        </Typography>
                                                        <Typography variant="caption">
                                                            {option.bidang_studi_id_str}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        )
                                    })}
                                {/* </Paper> */}
                            </Paper>
                        </FuseAnimate>
                    </div>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getPengguna: Actions.getPengguna,
        setPengguna: Actions.setPengguna,
        getPeran: Actions.getPeran,
        toggleFormPengguna: Actions.toggleFormPengguna,
        setLoading: Actions.setLoading,
        setLoadingBesar: Actions.setLoadingBesar,
        getPtkDapodik: Actions.getPtkDapodik,
        salinPesertaDidik: Actions.salinPesertaDidik
    }, dispatch);
}

function mapStateToProps({ Pengguna, App }) {

    return {
        pengguna: Pengguna.pengguna,
        peran: Pengguna.peran,
        hasil_pengguna: Pengguna.hasil_pengguna,
        toggle_form_pengguna: Pengguna.toggle_form_pengguna,
        loading: App.loading,
        ptk_dapodik: Pengguna.ptk_dapodik
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(DaftarPtkDapodik)));



// WEBPACK FOOTER //
// ./src/main/content/Pengaturan/DaftarPtkDapodik.js